<div class="searchbar-block">
    <input class="docs-searchbar" type="text" [(ngModel)]="searchInput" (keyup)='setFilterList()'>
    <div class="delete-icon" (click)="searchInput=''; setFilterList()"></div>
</div>
